
export default {
  name: "VerticalTabs",
  props: {
    features: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    const tl = this.$gsap.timeline({
      scrollTrigger: {
        trigger: ".content-container",
        start: "top 70px",
        end: "bottom+=2000",
        scrub: 3,
        pin: ".main",
        anticipatePin: 1,
        pinSpacing: true,
      },
    });

    tl.set(".moving-card", {
      y: "100vh",
    });

    tl.to(".moving-card", {
      y: 40,
      duration: 3,
      stagger: 2.5,
      ease: "sine.out",
    });
    tl.to(
      ".moving-card",
      {
        y: 0,
        duration: 3,
        stagger: 2.5,
        delay: 3,
        ease: "power.out",
      },
      "<"
    );
  },
};
